<template>
  <ElTabs v-model="refVal">
    <slot />
  </ElTabs>
</template>

<script lang="ts">
import { defineComponent, ref, watch, PropType } from 'vue';
import { ElTabs } from 'element-plus';
import { isBoolean } from 'lodash-es';
import { ActiveTabs } from '../core/types';

/**
 * 将element-plus的el-tabs组件的v-model ref转到reactive
 */
export default defineComponent({
  extends: [ElTabs],
  props: {
    // 开启hidden后, 切换table时不销毁组件
    useHidden: { type: Boolean, default: false },
    activeTab: { type: Object as PropType<ActiveTabs>, required: true }
  },

  setup(props) {
    let activeTabName = '';
    for (let [key, val] of Object.entries(props.activeTab)) {
      if (isBoolean(val) && val) {
        activeTabName = key;
        break;
      }
    }

    const refVal = ref(activeTabName);
    // eslint-disable-next-line vue/no-setup-props-destructure
    const activeTab = props.activeTab;
    activeTab.$name = activeTabName;

    const hiddenValue = props.useHidden ? 'hidden' : false;
    watch(
      refVal,
      (newValue, oldValue) => {
        let name = activeTab.$name;
        if (oldValue) {
          activeTab[oldValue] = hiddenValue;
          name = '';
        }

        if (newValue) {
          activeTab[newValue] = true;
          name = newValue;
        }
        activeTab.$name = name;
      },
      { immediate: true }
    );

    return { refVal };
  }
});
</script>
